import type {AxiosInstance} from 'axios';
import type {NewsLetterSuccessResponseRefId} from 'types/newsletter';
import {ENDPOINTS} from 'general/constants';
import {logWithSentry} from 'sentry/sentry';

/**
 * fetches user refId based on its email
 * @param {AxiosInstance} instance - instance for correct request
 * @param {string} email - user's email
 * @returns {Promise<string>} - user's ref id
 */
export const getRefId = async (instance: AxiosInstance, email: string): Promise<string> => {
    if (!email) return '';
    try {
        const response = await instance.post<NewsLetterSuccessResponseRefId>(
            ENDPOINTS.CUSTOMER_REFID,
            {email},
        );
        return response?.data?.refId;
    } catch (error) {
        logWithSentry(error as Error);
        return '';
    }
};
